import React, { useState } from "react";
import { Link } from "react-router-dom";
import Contactform from "./contactform";

const Partner = ({ reference }) => {
  return (
    <>
      <section className="partnerSection" ref={reference}>
        <div className="container" style={{ marginTop: "30px" }}>
          <div className="row">
            <div className="col-xl-5 col-lg-5 col-md-6 mb-5 mb-md-0">
              <div className="heading">
                <h4 data-aos="slide-down">
                  Your Trusted Destination to Hire Highly Skilled and Dedicated
                  Remote Developers.
                </h4>
                <p data-aos="slide-down">
                  Our team is equipped to handle any technical challenge, with a
                  relentless focus on delivering excellence to our customers.
                </p>
                <Link to="/HireDeveloper" className="btn" data-aos="fade-up">
                  <span>Hire Top Developer</span>
                </Link>
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 col-md-6 ml-auto"
              data-aos="zoom-in"
            >
              <Contactform />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partner;
